import React, { useState, useEffect } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline'; // ✅ NEW
import Placeholder from '@tiptap/extension-placeholder'; // ✅ NEW
import '../style/templateModal.css';

const TemplateModal = ({ onSave, onClose, selectedTemplate, templateType }) => {
    const [templateName, setTemplateName] = useState('');

    const editor = useEditor({
        extensions: [
            StarterKit,
            Underline,
            Placeholder.configure({
                placeholder: 'Insert text here...',
            }),
        ],
        content: '',
    });

    useEffect(() => {
        if (selectedTemplate) {
            setTemplateName(selectedTemplate.templateName || '');
            if (editor) {
                editor.commands.setContent(selectedTemplate.templateDetails || '');
            }
        } else {
            setTemplateName('');
            if (editor) {
                editor.commands.setContent('');
            }
        }
    }, [selectedTemplate, editor]);

    const handleSave = () => {
        if (!editor) return;
        const templateDetails = editor.getHTML().trim();
        const plainText = editor.getText().trim(); // get plain text content
    
        if (!templateName.trim() || !plainText) {
            alert("Template Name and Template Details cannot be empty.");
            return;
        }
    
        onSave(templateType, templateName.trim(), templateDetails);
    };
    
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>{selectedTemplate ? 'Edit Template' : 'Add Template'}</h2>
                <div className="form-layout">
                    <div className="template-name-section">
                        <label htmlFor="templateName">Template Name</label>
                        <input
                            type="text"
                            id="templateName"
                            value={templateName}
                            onChange={(e) => setTemplateName(e.target.value)}
                        />
                    </div>

                    <div className="template-details-section">
                        {editor && (
                            <>
                                <div className="editor-toolbar inside-box">
                                    <button
                                        onClick={() => editor.chain().focus().toggleBold().run()}
                                        className={editor.isActive('bold') ? 'is-active' : ''}
                                    >
                                        <b>B</b>
                                    </button>
                                    <button
                                        onClick={() => editor.chain().focus().toggleItalic().run()}
                                        className={editor.isActive('italic') ? 'is-active' : ''}
                                    >
                                        <i>I</i>
                                    </button>
                                    <button
                                        onClick={() => editor.chain().focus().toggleUnderline().run()}
                                        className={editor.isActive('underline') ? 'is-active' : ''}
                                    >
                                        <u>U</u>
                                    </button>
                                </div>
                                <EditorContent editor={editor} />
                            </>
                        )}
                    </div>
                </div>
                <div className="button-group">
                    <button className="cancel-button-modal" onClick={onClose}>Cancel</button>
                    <button className="save-button" onClick={handleSave}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default TemplateModal;
